<template style="height: 100%;">
    <div class="CommonContentSingle-white">
        <ul>
            <li v-for="(item, index) in TableConfigList" :key="index">{{ item.TableName }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            TableConfigList: []
        }
    },
    methods: {

    },
    mounted() {
        this.$Http_Post('ReportCriData/GetTableConfigListByType', { TableType: 3 }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
                this.TableConfigList = res.Data.List;
            }
        });
    },
}
</script>
<style>

</style>